<div
  #popoverRef
  class="popover {{ effectivePlacement }}"
  [style.top]="top + 'px'"
  [style.left]="left + 'px'"
  [class.in]="isIn"
  [class.fade]="animation"
  [class.visible]="visibility"
>
  <div [hidden]="!closeOnMouseOutside" class="virtual-area"></div>
  <div class="arrow"></div>
  <h3 class="popover-title" [hidden]="!title">{{ title }}</h3>
  <div class="popover-component">
    <ng-content></ng-content>
    {{ content }}
  </div>
</div>
